// Единый источник правды всех возможных атрибутов блоков статьи для редактора

// TODO: перевести в Schema
export const JOURNAL_TAG_ATTRIBUTES = {
  image: {
    main: 'data-image',
    src: 'data-img-src',
    label: 'data-img-label',
    alt: 'data-img-alt',
    labelLink: 'data-img-link',
    isPortrait: 'data-portrait',
    url: 'data-img-url',
    modifiers: {
      authorQuote: 'authorQuote',
    },
  },

  readMore: { main: 'data-read-more', link: 'data-more-link', anchor: 'data-more-anchor' },

  articleBanner: {
    app: 'data-app-banner',
    web: 'data-web-article-banner',
    bannerId: 'data-banner-id',
  },

  // Depricated, do not use
  banner: {
    main: 'data-web-banner',
    type: 'data-banner',
    title: 'data-banner-title',
    description: 'data-banner-description',
    buttonText: 'data-banner-button',
    link: 'data-banner-link',
  },

  financingWidget: {
    main: 'data-web-financing-widget',
    type: 'data-financing-widget',
    title: 'data-financing-widget-title',
    description: 'data-financing-widget-description',
    buttonText: 'data-financing-widget-button',
    financingProductId: 'data-financing-widget-financing-product-id',
    financingOfferType: 'data-financing-widget-financing-offer-type',
  },

  subscribe: {
    main: 'data-subscribe',
    header: 'data-subscribe-header',
    message: 'data-subscribe-message',
    url: 'data-message-url',
  },
  media: { main: 'data-publication-media', url: 'data-media-url', modifiers: { youtube: 'Youtube', yaMaps: 'YaMaps', rutube: 'Rutube' } },
  colors: { main: 'data-color', modifiers: { accent: 'accent' } },
  format: { main: 'data-format', modifiers: { bold: 'bold', contents: 'contents' } },
  anchor: { main: 'data-anchor' },
} as const

export const JOURNAL_REG_EXP = {
  youtube: new RegExp(/(?:https?:\/\/)?(?:www\.)?youtu\.?be(?:\.com)?\/?.*(?:watch|embed)?(?:.*v=|v\/|\/)([\w-_]+)/, 'i'),
  yamaps: new RegExp(/(?<=um=constructor)(.*)(?=&amp;width|&amp;source|&source=constructorLink)/),
  rutube: new RegExp(/(rutube\.ru\/video\/)([a-zA-Z0-9]+)/),
  isAbsoluteArticleLink: new RegExp(/http|journal|publication/),
  getArticleSlug: new RegExp(/(?<=publication\/)[a-z0-9-]*$/),
  isCorrectArticleSlug: new RegExp(/^\/?[a-z0-9-]+$/),
} as const

export const MAX_UPLOADED_FILE_SIZE = 10485760
